import TrackerDataTableView from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.js'
import WorkPackage from '@/applications/sales/components/WorkPackage/WorkPackage.vue'
import WorkPackageV3 from '@/applications/sales/components/WorkPackageV3/WorkPackageV3.vue'

import authorizationMixin from '@/agilis/components/DataTableV2/common/authorizationMixin'

import { mapGetters } from 'vuex'

import Vue from 'vue'

export default {
  name: 'PropositionTableView',
  mixins: [TrackerDataTableView, authorizationMixin],

  components: {
    WorkPackage,
    WorkPackageV3
  },

  data () {
    return {
      allWorkpackages: [],
      workpackages: [],
      workpackages3: [],
      deliveryDTO: null,
      orderDTO: null
    }
  },

  computed: {
    ...mapGetters({
      userIsAdmin: 'userDataStore/userIsAdmin'
    }),

    jlAssertionContext () { // extend computed prop from the mixin
      const parentContext = TrackerDataTableView.computed.jlAssertionContext.apply(this)
      let context = {
        ...parentContext,
        workpackages: this.allWorkpackages, // adding workpackages to the assertion context,
        parentTrackerDTO: this.parentTrackerDTO // adding parent tracker infos
      }

      context['deliveryDTO'] = this.deliveryDTO
      context['orderDTO'] = this.orderDTO

      return context
    }
  },

  watch: {
    children () {
      this.syncDeliveryDTO()
    },
    associations () {
      this.syncDeliveryDTO()
    }
  },

  methods: {
    syncDeliveryDTO () {
      const deliveryFromChildren = this.children?.find(child => child.trackerTypeId === 'delivery')
      const deliveryFromAssociations = this.associations?.find(association => association.type === 'relatedToDelivery')
      this.deliveryDTO = deliveryFromChildren || deliveryFromAssociations?.target

      if (this.deliveryDTO) {
        this.fetchDeliveryAssociations()
      } else {
        this.orderDTO = null
      }
    },

    fetchDeliveryAssociations () {
      const url = Vue.axios.agilisUrlTrackerAssociations(
        this.deliveryDTO.applicationId,
        this.deliveryDTO.trackerTypeId,
        this.deliveryDTO.id)
      Vue.axios
        .get(
          url,
          Vue.axios.agilisRequestConfig(url))
        .then((response) => {
          const deliveryAssociations = response.data
          const orderAssociation = deliveryAssociations.find(association => association.type === 'relatedToOrder')
          this.orderDTO = orderAssociation ? orderAssociation.target : null
        })
        .catch((error) => {
          if (error?.response?.status !== 401) this.notifyError(error)
        })
    },
    // Callback used to receive from Workpackages callback the update workpackages
    onWorkPackagesUpdated (ww) {
      this.workpackages = ww
      this.allWorkpackages = [
        ...this.workpackages,
        ...this.workpackages3
      ]
      this.requestHistoryReload()
    },

    onWorkPackagesUpdated3 (ww) {
      this.workpackages3 = ww
      this.allWorkpackages = [
        ...this.workpackages,
        ...this.workpackages3
      ]
      this.requestHistoryReload()
    }
  }
}
